import React, { useState, useEffect } from 'react';

// material-ui
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import useApi from 'hooks/useApi';
import VenueService from 'services/VenueService';

export default function TurfDetails({ venueUuid, sportsTypes }) {

    const theme = useTheme();
    const [rows, setRows] = useState([]);

    const getSportsType = function (typesString) {
        const splitTypes = typesString.split(',');
        return splitTypes.map(x => {
            let findInd = sportsTypes.findIndex(st => st.code === x);
            return findInd >= 0 ? sportsTypes[findInd].display_name : '';
        }).toString();
    };

    const getTurfListHandler = (response) => {
        const data = response.data;
        setRows(data.rows);
    };

    const getTurfListApi = useApi(VenueService.getTurfList, getTurfListHandler);

    useEffect(() => {
        getTurfListApi.execute({
            venueUuid
        });
    }, []);

    return (
        <Box sx={{ width: '100%', typography: 'body1' }}>
            <MainCard
            >
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ pl: 3 }}>#</TableCell>
                                <TableCell>Court Name</TableCell>
                                <TableCell>Sports Type</TableCell>
                                <TableCell align="center">Board Available</TableCell>
                                <TableCell align="center">Active</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.map((row, index) =>
                                    <TableRow key={index} hover>
                                        <TableCell sx={{ pl: 3 }}>{index + 1}</TableCell>
                                        <TableCell>{row.turf_name}</TableCell>
                                        <TableCell>
                                            {getSportsType(row.sports_type)}
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                row.is_board_available ? (
                                                    <Chip
                                                        label="Yes"
                                                        size="medium"
                                                        sx={{
                                                            background:
                                                                theme.palette.mode === 'dark'
                                                                    ? theme.palette.dark.main
                                                                    : theme.palette.success.light + 60,
                                                            color: theme.palette.success.dark
                                                        }}
                                                    />
                                                ) : (
                                                    <Chip
                                                        label="No"
                                                        size="medium"
                                                        sx={{
                                                            background:
                                                                theme.palette.mode === 'dark'
                                                                    ? theme.palette.dark.main
                                                                    : theme.palette.error.light + 60,
                                                            color: theme.palette.error.dark
                                                        }}
                                                    />
                                                )
                                            }
                                        </TableCell>
                                        <TableCell align="center">
                                            {
                                                row.is_active ? (
                                                    <Chip
                                                        label="Active"
                                                        size="medium"
                                                        sx={{
                                                            background:
                                                                theme.palette.mode === 'dark'
                                                                    ? theme.palette.dark.main
                                                                    : theme.palette.success.light + 60,
                                                            color: theme.palette.success.dark
                                                        }}
                                                    />
                                                ) : (
                                                    <Chip
                                                        label="Inactive"
                                                        size="medium"
                                                        sx={{
                                                            background:
                                                                theme.palette.mode === 'dark'
                                                                    ? theme.palette.dark.main
                                                                    : theme.palette.error.light + 60,
                                                            color: theme.palette.error.dark
                                                        }}
                                                    />
                                                )
                                            }
                                        </TableCell>
                                    </TableRow>
                                )
                            }
                        </TableBody>
                    </Table>
                </TableContainer >
            </MainCard>
        </Box>
    );
};
